import React from 'react';
import { Router } from '@reach/router';
import StripeContext from '~components/StripeContext';
import Layout from '~components/Layout';
import Registration from './Pages/Registration/Registration';
import Invitation from './Pages/Invitation/Invitation';
import NotFound from './Pages/NotFound/NotFound';
import { purchaseSources, InternationalRegisterPurchaseSources } from './components/OrderForm/constants';

import './App.module.scss';

export default function App() {
  return (
    <StripeContext>
      <Layout hideAll>
        <Router>
          <NotFound default />
          <Registration path="/register" type='us' purchaseSources={purchaseSources} />
          <Registration path="/register/international" type='international' purchaseSources={InternationalRegisterPurchaseSources} />
          <Invitation path="/invite" />
        </Router>
      </Layout>
    </StripeContext>
  );
}
